<template>
    <v-card class="primary darken-1">

        <v-layout column class="media ma-0">
            <v-card-title>
                <v-btn dark icon>
                    <v-icon>chevron_left</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn dark icon class="mr-3">
                    <v-icon>edit</v-icon>
                </v-btn>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-card-title class="white--text pl-1 pt-1">
                <div class="display-1 pl-5 pt-1"> {{ user.first_name }} {{ user.last_name }}</div>
            </v-card-title>
        </v-layout>

        <v-list two-line class="pa-0">
            <v-list-tile href="">
                <v-list-tile-action>
                    <v-icon color="primary">business</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{ user.client ? user.client.name : '-----' }}</v-list-tile-title>
                        <v-list-tile-sub-title>Organización</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider inset></v-divider>
            <v-list-tile href="#">
                <v-list-tile-action>
                    <v-icon color="primary">mail</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{ user.email }}</v-list-tile-title>
                    <v-list-tile-sub-title>Personal</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-card>
</template>

<script>
  export default {
    computed: {
      user () {
        return this.$store.getters['user/user']
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/ProfileView.vue